var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 =
    _vm.shop_info != "" && _vm.nav_type == 0
      ? _vm.__map(_vm.product_list, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var g0 = _vm.product_list.length
          return {
            $orig: $orig,
            g0: g0,
          }
        })
      : null
  var g1 =
    _vm.shop_info != "" && (_vm.nav_type == 0 || _vm.nav_type == 99)
      ? _vm.product_list.length == 0 && !_vm.loading
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
        g1: g1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }